import { panelsOf } from "@/lib/geometry";

const kind = (op) => (op === "sliding_left" || op === "sliding_right" ? "sliding"
  : op.startsWith("door") || op.startsWith("folding") ? "door"
  : op === "fixed" || op === "louvre" ? "fixed" : "casement");

export const JOINT_LABEL = { "sliding+fixed": "Sliding ↔ fixed", "sliding+casement": "Sliding ↔ casement / hung", "sliding+door": "Sliding ↔ door" };

export function findJoints(item) {
  const P = panelsOf(item), out = [];
  P.forEach((a) => P.forEach((b) => {
    let seg = null;
    if (a.x1 === b.x0) {
      const y0 = Math.max(a.y0, b.y0), y1 = Math.min(a.y1, b.y1);
      if (y1 > y0) seg = { o: "v", x0: a.x1, x1: a.x1, y0, y1 };
    } else if (a.y1 === b.y0) {
      const x0 = Math.max(a.x0, b.x0), x1 = Math.min(a.x1, b.x1);
      if (x1 > x0) seg = { o: "h", x0, x1, y0: a.y1, y1: a.y1 };
    }
    if (!seg) return;
    const ka = kind(a.op), kb = kind(b.op);
    if ((ka === "sliding") === (kb === "sliding")) return;
    const s = ka === "sliding" ? a : b, other = ka === "sliding" ? b : a, ko = kind(other.op);
    const rowSliding = P.filter((p) => kind(p.op) === "sliding" && p.y0 === s.y0 && p.y1 === s.y1).length;
    const auto = seg.o === "h" || ko !== "fixed" || rowSliding >= 2;
    const key = `${seg.o}-${Math.round(seg.x0)}-${Math.round(seg.y0)}`;
    out.push({
      key, orientation: seg.o, type: `sliding+${ko}`, x: (seg.x0 + seg.x1) / 2, y: (seg.y0 + seg.y1) / 2,
      length: Math.round(seg.o === "v" ? seg.y1 - seg.y0 : seg.x1 - seg.x0), auto, coupled: item.joints?.[key] ?? auto,
    });
  }));
  return out.sort((p, q) => p.y - q.y || p.x - q.x).map((j, i) => ({ ...j, mark: `J${i + 1}` }));
}

export const coupledJoints = (item) => findJoints(item).filter((j) => j.coupled);

export function jointPrims(item) {
  const E = Math.max(item.width, item.height), r = E * 0.024;
  return coupledJoints(item).flatMap((j) => [
    { t: "poly", pts: [[j.x, j.y - r], [j.x + r, j.y], [j.x, j.y + r], [j.x - r, j.y]], fill: "#FDE68A", weight: "medium", layer: "TAG", dxf: "JOINT" },
    { t: "text", x: j.x, y: j.y + r * 0.35, text: j.mark, h: r * 0.9, anchor: "middle", layer: "JOINTTEXT", bold: true, dxf: "JOINT" },
  ]);
}
